'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './faq-directory.routes';

export class FAQDirectoryComponent {
  constructor(SettingsService, $state, $stateParams, Config) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.SettingsService = SettingsService;

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Frequently Asked Questions");

    this.SettingsService.getByName({name: this.$stateParams.name}, setting => {
      this.data = setting.data;
    });
  }
}

export default angular.module('conduuApp.faqList', [uiRouter])
  .config(routes)
  .component('faqList', {
    template: require('./faq-directory.html'),
    controller: FAQDirectoryComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/directories/faq/list/faq-directory.component.js